import React, { Component } from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

class FullImage extends Component {

  render() {

    let { image, mobileImage, desktopHeight, mobileHeight } = this.props

    return (
      <section className='full-image'>
        <div className='full-image__inner'>
          <div className='full-image__content'>
            <img className='full-image__bg full-image__bg--mobile' src={mobileImage?.sourceUrl} style={{ height: `${mobileHeight}px` }} />
            <img className='full-image__bg full-image__bg--desktop' src={image?.sourceUrl} style={{ height: `${desktopHeight}px` }} />
          </div>
        </div>
      </section>
    )
  }
}

export default FullImage
